/// <amd-module name="Artifacts/Upack/components/UpackPackageOverview" />
import { PackageDeletedMessageCard } from "Artifacts/Package/components/package-details-common/PackageDeletedMessageCard";
import { PackageTile } from "Artifacts/Package/components/package-details-common/PackageTile";
import * as PackageRes from "Artifacts/Package/Resources";
import { CopyableTextField } from "Artifacts/Root/protocols/components/CopyableTextField";
import { IProtocolOverviewProps } from "Artifacts/Root/protocols/types";
import * as RootRes from "Artifacts/Root/Resources";
import { connectToFeed } from "Artifacts/Root/routing/Constants";
import { getCopyInstallCommand } from "Artifacts/Upack/helpers/InstructionsHelper";
import * as UpackRes from "Artifacts/Upack/Resources";
import * as React from "react";
import { generatePath, useHistory } from "react-router-dom";
import { useComponentContext } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";

const UpackOverview: React.FC<IProtocolOverviewProps> = ({ feed, pkg, version }) => {
  const { pageContext } = useComponentContext();
  const history = useHistory();

  const command = getCopyInstallCommand(pageContext, feed, pkg.name, version);
  const displayText = getCopyInstallCommand(pageContext, feed, pkg.name, version, " \\\n  ");

  return (
    <div className="package-overview-content">
      {version.isDeleted && (
        <PackageDeletedMessageCard version={version.version} packageName={pkg.name} />
      )}
      {!version.isDeleted && (
        <PackageTile title={UpackRes.UPack_InstallInstructions_Title}>
          <div className="package-command">
            <Button
              iconProps={{
                iconName: "PlugConnected",
              }}
              onClick={() => {
                history.push(generatePath(connectToFeed, { feedIdentifier: feed?.name }));
              }}
            >
              {RootRes.ConnectToFeedButton}
            </Button>
            <span className="install-instructions-then">
              {PackageRes.PackageDetails_InstallInstructions_then}
            </span>
            <CopyableTextField text={command}>{displayText}</CopyableTextField>
          </div>
        </PackageTile>
      )}
      {
        <PackageTile title={PackageRes.PackageDetails_Description}>
          <div className="package-description">{version.description}</div>
        </PackageTile>
      }
    </div>
  );
};

export { UpackOverview };
